import { mergeStyleSets } from "@fluentui/react";

export const useStyles = () => {
  return mergeStyleSets({
    filterManagerButton: {
      fontWeight: 600,
      width: '100%',
    },
    fieldDescription: {
      fontSize: '12px',
      marginTop: '4px',
      fontWeight: 300,
    },
    groupPane: {
      '& > div:first-child': {
        paddingLeft: '0',
        paddingRight: '0',
      }
    }
  })
};
